@if (this.leadDetail$ | async; as leadDetail) {
  <div
    class="tab-pane fade flex-even active show"
    id="sales"
    role="tabpanel"
    aria-labelledby="sales-tab"
    >
    <div class="d-flex flex-column h-100">
      <div class="row mt-2">
        <div class="col-12 col-md">
          <div class="form-group row">
            <label class="col-4 col-form-label-sm" translate
              >LEAD_LBL_MARKETING_CAMPAIGN</label
              >
              <div class="col">
                <span class="form-control-plaintext form-control-sm">
                  {{ leadDetail.campaignName }}
                </span>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-4 col-form-label-sm" translate
                >LEAD_LBL_MARKETING_MEDIUM</label
                >
                <div class="col">
                  <span class="form-control-plaintext form-control-sm">
                    {{ leadDetail.mediumName }}
                  </span>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-4 col-form-label-sm" translate
                  >LEAD_LBL_MARKETING_SOURCE</label
                  >
                  <div class="col">
                    <span class="form-control-plaintext form-control-sm">
                      {{ leadDetail.sourceName }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col">
                @if (leadDetail.campaignId === ReferralCampaign) {
                  <div class="form-group row">
                    <label class="col-4 col-form-label-sm" translate
                      >LEAD_LBL_MARKETING_REFERRER</label
                      >
                      <div class="col-auto">
                        <span class="form-control-plaintext form-control-sm">
                          @if (!leadDetail.contactReferrerId) {
                            {{ leadDetail.contactReferrerName }}
                          } @else {
                            <app-link-to
                              [id]="leadDetail.contactReferrerId.toString()"
                              [label]="leadDetail.contactReferrerName"
                              [url]="'/Contacts/Contacts/Details/'"
                              />
                            }
                          </span>
                        </div>
                      </div>
                    }
                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate
                        >LEAD_LBL_MARKETING_CREATION_DATE</label
                        >
                        <div class="col-auto">
                          <span class="form-control-plaintext form-control-sm">
                            {{ leadDetail.creationDate | toLocalTime: "dd/MM/yyyy HH:mm" }}
                          </span>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label class="col-4 col-form-label-sm" translate
                          >LEAD_LBL_LAST_STATUS_UPDATE_DATE</label
                          >
                          <div class="col-auto">
                            <span class="form-control-plaintext form-control-sm">
                              {{ leadDetail.lastStatusUpdate | toLocalTime : "dd/MM/yyyy" }}
                            </span>
                          </div>
                        </div>
                        @if (leadDetail.leadStatus == 'Lost') {
                          <div class="form-group row">
                            <label class="col-4 col-form-label-sm" translate
                              >LEAD_LBL_LOST_SUMMARY</label
                              >
                              <div class="col-auto">
                                <span class="form-control-plaintext form-control-sm">
                                  {{ leadDetail.lostSummary }}
                                </span>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                }
